import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import React from 'react';
import { I18n } from 'react-redux-i18n';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

class ResetPasswordInput extends React.Component {
  constructor() {
    super();
    this.state = {
      plainTextField: false,
    };
  }

  toggleFieldType = () => {
    this.setState((prevState) => ({
      plainTextField: !prevState.plainTextField,
    }));
  };

  onChange = ({ target: { value } }) => {
    this.props.onChange(value);
  };

  render() {
    return (
      <>
        <TextField
          label={I18n.t('resetPassword.form.inputLabel')}
          name="password"
          type={this.state.plainTextField ? 'text' : 'password'}
          value={this.props.value}
          onChange={this.onChange}
          error={this.props.error}
          disabled={this.props.disabled}
          className="settings__password-field"
        />
        <IconButton
          className="settings__password-icon"
          onClick={this.toggleFieldType}
        >
          <Icon>
            {this.state.plainTextField ? 'visibility_off' : 'visibility'}
          </Icon>
        </IconButton>
      </>
    );
  }
}

ResetPasswordInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
};

ResetPasswordInput.defaultProps = {
  value: '',
  error: false,
  disabled: false,
};

export default ResetPasswordInput;
